import { QueryClientProvider } from '@tanstack/react-query';
import queryClient from '@core/services/queryClient';
import { AuthProvider } from '@core/providers/AuthProvider';
import { UiProvider } from '@core/providers/UiProvider';
import I18nProvider from '@core/providers/I18nProvider';
import DebugPanelGuard from '@core/components/DebugPanel/DebugPanelGuard';
import { Overlay } from '@core/components/Overlay/Overlay';
import { FileViewer } from '@core/components/FileViewer/FileViewer';
import '@core/styles/index.scss';
import { PresentationMode } from '@core/components/PresentationMode/PresentationMode';
import ConnectionAlertBar from '@core/components/ConnectionAlertBar/ConnectionAlertBar';

const App = () => (
    <AuthProvider>
        <PresentationMode reverse={true}>
            <DebugPanelGuard />
        </PresentationMode>
        <QueryClientProvider client={queryClient}>
            <I18nProvider>
                <ConnectionAlertBar />
                <UiProvider />
                <Overlay />
                <FileViewer />
            </I18nProvider>
        </QueryClientProvider>
    </AuthProvider>
);

export default App;
